module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "default",
    attrs: {
      "id": "d8e75NaN"
    }
  }), _c('p', {
    staticClass: "crth",
    attrs: {
      "id": "d7e292"
    }
  }, [_vm._v("Nightmare in Niceville "), _c('br'), _vm._v("© 2011 Amberle Cianne. All Rights Reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d7e402"
    }
  }, [_vm._v("No part of this book may be reproduced in any form or by any means, electronic, mechanical, digital, photocopying, or recording, except for the inclusion in a review, without permission in writing from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d7e522"
    }
  }, [_vm._v("First edition.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d7e572"
    }
  }, [_vm._v("This is a work of fiction. All of the characters, names, incidents, organizations, and dialogue in this novel are either the products of the author’s imagination or are used fictitiously.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d7e692"
    }
  }, [_vm._v("Published in the U.S. by BQB Publishing Company"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.bqbpublishing.com",
      "id": "d14e67",
      "target": "_blank"
    }
  }, [_vm._v("www.bqbpublishing.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d14e69"
    }
  }, [_vm._v("Printed in the United States of America ")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d14e71"
    }
  }, [_vm._v("ISBN 978-0-9831699-4-9 (p)"), _c('br'), _vm._v("ISBN 978-1-937084-42-4 (e) ")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d14e75"
    }
  }, [_vm._v("Library of Congress Control Number: 2011940348")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d14e77"
    }
  }, [_vm._v("Cover painting by Michael Mustachio"), _c('br'), _vm._v("Book interior by Robin Krauss, Linden Design, "), _c('a', {
    attrs: {
      "href": "http://www.lindendesign.biz",
      "id": "d14e81",
      "target": "_blank"
    }
  }, [_vm._v("www.lindendesign.biz")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ff608bf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cian_9781937084424_epub_c4_r1.vue
// module id = 60
// module chunks = 0